module.exports = __webpack_public_path__ + "media/theme/icon__status--sent-71cefc6d.svg";